import { render, staticRenderFns } from "./AvatarDescription.vue?vue&type=template&id=43253afd&scoped=true&"
import script from "./AvatarDescription.vue?vue&type=script&lang=ts&"
export * from "./AvatarDescription.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarDescription.vue?vue&type=style&index=0&id=43253afd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43253afd",
  null
  
)

export default component.exports